import React from 'react';
import styled from 'styled-components';

import {Label, LabelText, RadioInput} from './ui';

export interface FormRadioProps {
    name: string;
    value: string;
    checked?: boolean;
    label?: string;
    color?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    className?: string;
}

export const RawFormRadio: React.FC<FormRadioProps> = ({name, value, checked, label, color, children, onChange, className}) => (
    <Label className={className}>
        <RadioInput aria-label={label} value={value} name={name} onChange={onChange} defaultChecked={checked} $color={color} $hasLabel={!!label} />
        {children ? children : <LabelText>{label}</LabelText>}
    </Label>
);

export const FormRadio = styled(RawFormRadio)``;
